var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeaderSigninIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 27,
    viewBox: "0 0 32 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0428 0H26.3212C28.9754 0 31.1345 1.83954 31.1345 4.10046V22.4554C31.1345 24.716 28.9757 26.5556 26.3212 26.5556H13.0428C12.6831 26.5556 12.3911 26.3068 12.3911 26.0004V24.3349C12.3911 24.0284 12.6831 23.7797 13.0428 23.7797H26.3212C27.1782 23.7797 27.8759 23.1857 27.8759 22.4554V4.10018C27.8759 3.37014 27.1789 2.77583 26.3212 2.77583H13.0428C12.6831 2.77583 12.3911 2.52712 12.3911 2.22067V0.555167C12.3911 0.248715 12.6831 0 13.0428 0ZM25.619 13.759L12.7649 20.0815C12.6642 20.1306 12.5518 20.1551 12.4393 20.1551C12.3269 20.1551 12.2145 20.1306 12.1135 20.0807C11.9118 19.9816 11.7876 19.7987 11.7876 19.5999V16.6564H0.691146C0.331398 16.6564 0.0394287 16.4077 0.0394287 16.1012V10.4541C0.0394287 10.1476 0.331398 9.89892 0.691146 9.89892H11.7873V6.95515C11.7873 6.75696 11.9114 6.57348 12.1131 6.47438C12.3149 6.37528 12.5632 6.37528 12.7649 6.47438L25.619 12.7977C25.8207 12.8968 25.9449 13.0806 25.9449 13.2785C25.9449 13.4764 25.8207 13.6602 25.619 13.759Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderSigninIcon);
export default __webpack_public_path__ + "static/media/header_signin_icon.0248815cca2bef339db2b83322509a82.svg";
export { ForwardRef as ReactComponent };